const EXPORTS_BASE = process.env.VUE_APP_EXPORTS_URL
    || 'https://us-central1-fiancar-terminal.cloudfunctions.net/exports'

export function normalizeExportParams(params) {
    const normalized = { ...params }
    if (Array.isArray(normalized.dates)) {
        normalized.dates = normalized.dates.join(',')
    }
    return normalized
}

export function buildExportUrl(endpoint, params) {
    const query = params instanceof URLSearchParams
        ? params.toString()
        : new URLSearchParams(normalizeExportParams(params)).toString()
    return `${EXPORTS_BASE}/${endpoint}${query ? `?${query}` : ''}`
}
